import { Button, Modal } from "antd";
import { useCallback, useEffect, useState } from "react";

interface AdditionalFilesSummaryProps {
  fileName: string;
  fileUrl: string;
}

export const AdditionalFilesSummary: React.FC<AdditionalFilesSummaryProps> = ({
  fileName, fileUrl
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = (
  ) => {
    setIsModalVisible(true);
  };


  const handleCancel = () => {
    setIsModalVisible(false);
  };
    
  const formattedFileName = fileName.split("/").pop() ?? "";

  const handleDownload = useCallback(() => {
    fetch(fileUrl)
      .then((response) => response.ok ? response.blob() : Promise.reject("Network response was not ok"))
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = formattedFileName || "download.pdf";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Download failed:", error);
        
      });
  }, [fileUrl, formattedFileName]);

  useEffect(() => () => {
    URL.revokeObjectURL(fileUrl);
  }, [fileUrl]);

  return (
    <div className="flex items-center space-x-6">
      <Button type="primary" onClick={handleDownload}>Download</Button>
      <Button type="primary" onClick={() => showModal()}>View</Button>
      <span>{formattedFileName}</span>
       <Modal
        title={`Preview: ${formattedFileName}`}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={800}
      >
        <embed
          src={fileUrl}
          width="100%"
          height="500px"
          style={{ border: "none" }}
          title={`PDF Preview: ${formattedFileName}`}
        />
      </Modal>
    </div>
  );
};
